"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("phaser");
const GameConstants_1 = require("./GameConstants");
const Scene_1 = require("./Scene");
const StartScene_1 = require("./StartScene");
document.body.style.margin = '0';
document.body.style.padding = '0';
document.body.style.overflow = 'hidden';
document.body.style.backgroundColor = '#000000';
document.addEventListener('contextmenu', event => event.preventDefault());
const config = {
    type: Phaser.AUTO,
    width: window.innerWidth,
    height: window.innerHeight,
    backgroundColor: '#000000',
    scene: [StartScene_1.StartScene, Scene_1.Scene],
    scale: {
        mode: Phaser.Scale.RESIZE,
        autoCenter: Phaser.Scale.CENTER_BOTH,
    },
    physics: {
        default: 'arcade',
        arcade: {
            debug: false,
            // debugShowVelocity: true,
            x: 0,
            y: 0,
            width: GameConstants_1.GameConstants.boundaryWidth,
            height: GameConstants_1.GameConstants.boundaryHeight,
        }
    }
};
const game = new Phaser.Game(config);
if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
        const registration = await navigator.serviceWorker.register('/service-worker.js');
        console.log('ServiceWorker registration successful with scope: ', registration.scope);
    });
}
